import {FacetValueForInterface} from '../interfaces/assets-search-results.interface';

export class FacetSortUtils {


    public static sortBySizeOrder(value1:FacetValueForInterface, value2:FacetValueForInterface){
        if (value1.count < value2.count) {
            return 1;
        } else if (value1.count > value2.count) {
            return -1;
        }
        return 0;
    }

    public static sortByAlphabeticalOrder(value1:FacetValueForInterface, value2:FacetValueForInterface){
        if (value1.label > value2.label) {
            return 1;
        } else if (value1.label < value2.label) {
            return -1;
        }
        return 0;
    }



}
